import gsap, { snap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger"
import moment from 'moment-timezone';
import SplitType from 'split-type';
import Exp from '../experience/Exp'
gsap.registerPlugin(ScrollTrigger);


export function getTime() {
    console.log('getTime')
    let timeSg = document.querySelector('.getTime.--sg');
    let timeVn = document.querySelector('.getTime.--vn');
    function updateTime() {
        let AustraliaTime = moment.tz("Australia/Sydney").format("hh:mma");
        timeSg.innerHTML = AustraliaTime;
        let vietnamTime = moment.tz("Asia/Bangkok").format("hh:mma")
        timeVn.innerHTML = vietnamTime;
    };
    updateTime();
    setInterval(function () {
        updateTime();
    }, 60000);
}

export function headerLogoOnScroll() {
    let direction = 1;
    const tl = gsap.timeline({
        repeat: -1,
    })

    tl.to('.header .logo-typo', { rotate: 360, duration: 180, ease: 'none' })
    tl.timeScale(0)

    const scroll = ScrollTrigger.create({
        trigger: document.querySelector('html'),
        onUpdate(self) {
            //let velo = gsap.utils.clamp(0, 2, Math.abs(window.SCROLL.velocity).toFixed(2));
            let velo = Math.abs(window.SCROLL.velocity).toFixed(2);
            if (self.direction !== direction) {
                direction *= -1;
            };
            gsap.set(tl, { timeScale: velo * direction, overwrite: true })
        }
    })
}

export function cursor() {
    const customCursor = document.querySelector('.cursor');
    const customCursorSm = document.querySelector('.cursor-inner');
    let clientX = -100;
    let clientY = -100;
    let lastX = 0;
    let lastY = 0;
    let lastXSm = 0;
    let lastYSm = 0;
    document.addEventListener('pointermove', function (e) {
        clientX = e.clientX;
        clientY = e.clientY;
    })
    for (let x = 0; x < document.querySelectorAll('a').length; x++) {
        document.querySelectorAll('a')[x].addEventListener('pointerenter', function (e) {
            customCursor.classList.add('hover');
            customCursorSm.classList.add('hover');
        })
        document.querySelectorAll('a')[x].addEventListener('pointerleave', function (e) {
            customCursor.classList.remove('hover');
            customCursorSm.classList.remove('hover');
        })
    }

    const lerp = (a, b, n) => {
        return (1 - n) * a + n * b;
    };

    const render = () => {
        lastX = lerp(lastX, clientX, 0.1);
        lastY = lerp(lastY, clientY, 0.1);
        lastXSm = lerp(lastXSm, clientX, 1);
        lastYSm = lerp(lastYSm, clientY, 1);
        customCursor.style.transform = `translate(${lastX}px, ${lastY}px`;
        customCursorSm.style.transform = `translate(${lastXSm}px, ${lastYSm}px`;
        requestAnimationFrame(render)
    };
    requestAnimationFrame(render)
}

export function handleHeaderToggle() {
    const menuToggleTxt = SplitType.create(document.querySelector('.header .menu-toggle .txt'), { types: 'chars' });
    document.querySelector('.header .menu-toggle').addEventListener('pointerenter', () => {
        gsap.to(menuToggleTxt.chars, { 'color': '#ffffff', duration: .4, stagger: .05 })
    })
    document.querySelector('.header .menu-toggle').addEventListener('pointerleave', () => {
        gsap.to(menuToggleTxt.chars, { 'color': '#ffffff30', duration: .4, stagger: .05 })
    })
}
export function handleLogoHover() {
    let exp = new Exp();
    const logoIcon = document.querySelector('.header .logo-icon');

    let xSetter = gsap.utils.pipe(
        gsap.utils.clamp(-45, 45),
        gsap.quickSetter('.header .logo-icon', 'rotateY', 'deg')
    )
    let ySetter = gsap.utils.pipe(
        gsap.utils.clamp(-45, 45),
        gsap.quickSetter('.header .logo-icon', 'rotateX', 'deg')
    )
    let lerp = (a, b, c) => {
        let value = (a - b) * c
        return value
    }

    console.log(logoIcon.getBoundingClientRect().x)
    function move() {
        if (document.querySelector('.logo-inner').matches(':hover')) {
            let xLimit = gsap.utils.normalize(logoIcon.getBoundingClientRect().x, logoIcon.getBoundingClientRect().x + logoIcon.getBoundingClientRect().width, exp.followCursor.x)
            let yLimit = gsap.utils.normalize(logoIcon.getBoundingClientRect().y, logoIcon.getBoundingClientRect().y + logoIcon.getBoundingClientRect().height, exp.followCursor.y)
            // xSetter((xLimit - 0.5) * 80);
            // ySetter((yLimit - 0.5) * -80);
            gsap.set(logoIcon, {
                rotateY: gsap.utils.clamp(-15, 15, (xLimit - 0.5) * 100),
                rotateX: gsap.utils.clamp(-15, 15, (yLimit - 0.5) * -100),
                // rotateY: lerp(gsap.getProperty(".header .logo-icon", "rotateY"), gsap.utils.clamp(-45, 45, (xLimit - 0.5) * 200), 0.1),
                // rotateX: lerp(gsap.getProperty(".header .logo-icon", "rotateX"), gsap.utils.clamp(-45, 45, (yLimit - 0.5) * -200), 0.1),
            })
        } else {
            gsap.to(logoIcon, { rotateX: 0, rotateY: 0, duration: .3, overwrite: true })
        }

        requestAnimationFrame(move)
    }
    requestAnimationFrame(move)

}